export default {
  namespaced: false,
  state: () => ({
    AstroCalendarNoteEdit: {
      CalendarNoteId: "",
      Content: "",
      Moods: "",
      MoodContent: "",
      Date: "",
      Title: "", //後端不存在資料庫，前端使用
    },
    showCalendarNoteAlreadyWrite: false,
  }),
  getters: {
    astroCalendarNoteEdit: (state) => {
      return state.AstroCalendarNoteEdit;
    },
    showCalendarNoteAlreadyWrite: (state) => {
      return state.showCalendarNoteAlreadyWrite;
    },
  },
  mutations: {
    setAstroCalendarNoteEdit(state, payload) {
      state.AstroCalendarNoteEdit = {
        ...state.AstroCalendarNoteEdit,
        ...payload,
      };
    },
    setShowCalendarNoteAlreadyWrite(state, payload) {
      state.setShowCalendarNoteAlreadyWrite = payload;
    },
  },

  actions: {},
};
